import { Timestamp } from '@bufbuild/protobuf';

import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform, inject } from '@angular/core';

@Pipe({
  name: 'customDate',
  standalone: false,
})
export class CustomDatePipe implements PipeTransform {
  datePipe = inject(DatePipe);
  transform(
    value: Date | string | number | Timestamp | undefined | null,
    format: string = 'mediumDate',
    timezone?: string,
    locale?: string
  ): string | null {
    if (!value) {
      return '';
    }
    const isTimestamp = value && typeof value === 'object' && 'nanos' in value;
    const dateValue = isTimestamp
      ? (value.toJson() as string)
      : (value as string);

    return this.datePipe.transform(dateValue, format, timezone, locale);
  }
}
